

















import { createComponent, computed } from "@vue/composition-api";
import {
  SelectInputProps,
  defaultGetLabel,
  defaultGetOptionKey,
} from "./selectProps";

type SelectInputOption = {
  value: any;
  label: string;
  key: string | number;
};

export default createComponent<SelectInputProps<any>>({
  props: {
    options: { required: true },
    value: { required: true },
    getOptionLabel: { type: Function, default: defaultGetLabel },
    getOptionKey: { type: Function, default: defaultGetOptionKey },
    multiple: { type: Boolean, default: false },
  },

  setup(props, ctx) {
    const assignKey = (option: any) => {
      if (typeof option !== "object") return option;
      return {
        ...option,
        key: props.getOptionKey(option),
      };
    };

    const optionsWithKeys = computed(() => {
      if (!props.options) return [];
      return props.options.map(assignKey);
    });

    const valueWithKey = computed(() => {
      return (
        props.value &&
        (props.multiple ? props.value.map(assignKey) : assignKey(props.value))
      );
    });

    return {
      optionsWithKeys,
      valueWithKey,
    };
  },
});
